import Layout from 'antd/lib/layout';
import React, { useMemo } from 'react';
import { useOverscrollBehaviorFix } from '../../../../components/sidebar-filters/useOverscrollBehaviorFix';
import { ENERGY_USAGE_PAGE_CONST } from '../constants';

interface IEnergyUsageSidebarWrapperProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    children: React.ReactNode;

    siteFiltersCollapsed: boolean;
    setSiteFiltersCollapsed: (value: boolean) => void;
}

export const EnergyUsageSidebarWrapper: React.FC<IEnergyUsageSidebarWrapperProps> = ({
    children,
    collapsed,
    onCollapseChange,
    siteFiltersCollapsed,
}) => {
    useOverscrollBehaviorFix();

    const siderWidth = useMemo(() => {
        if (!siteFiltersCollapsed) return ENERGY_USAGE_PAGE_CONST.expandedWidth;

        return ENERGY_USAGE_PAGE_CONST.sitesPanelWidth + ENERGY_USAGE_PAGE_CONST.filtersCollapsedWidth;
    }, [siteFiltersCollapsed]);

    return (
        <Layout.Sider
            collapsible
            theme="light"
            collapsedWidth={ENERGY_USAGE_PAGE_CONST.filtersCollapsedWidth}
            width={siderWidth}
            collapsed={collapsed}
            onCollapse={onCollapseChange}
            style={{
                background: collapsed ? 'var(--ant-color-primary)' : 'white',

                position: 'fixed',
                left: 0,
                top: 64,
                bottom: 0,
                zIndex: 1000,

                // Disable collapse animation
                transition: 'none',

                borderTop: `1px solid #d9d9d9`,
                boxShadow: '5px 2px 5px rgba(0, 0, 0, 0.15)',
            }}
            trigger={null}
        >
            {children}
        </Layout.Sider>
    );
};
